import { computed } from 'vue';
import { useStore } from 'vuex';
import {
  formatAverageRating,
  formatNumberOfRatings,
  getStarLabel,
  getStarsUrl,
} from 'Main/reviews/misc/helpers';

export function useReviews() {
  const store = useStore();

  const reviewsData = computed(() => store.state.reviews.data);
  const bannerSummary = computed(() => store.state.reviews.bannerSummary);
  const isLoadingReviews = computed(() => store.state.reviews.isLoadingReviews);
  const isLoadingBanner = computed(() => store.state.reviews.isLoadingBanner);
  const modalReview = computed(() => store.state.reviews.modalReview);

  const averageRating = computed(() => {
    return formatAverageRating(reviewsData.value.average_rating);
  });

  const numberOfRatings = computed(() => {
    return formatNumberOfRatings(reviewsData.value.total_reviews);
  });

  const reviews = computed(() => {
    if (!Object.keys(reviewsData.value).length) {
      return [];
    }

    if (reviewsData.value.top_reviews_for_resource_type) {
      return reviewsData.value.top_reviews_for_resource_type;
    }

    return reviewsData.value.top_reviews || [];
  });

  function getReviewsSummary(pageType?: string) {
    return store.dispatch('reviews/getReviewsSummary', pageType);
  }

  function getReviewSummaryForBanner() {
    return store.dispatch('reviews/getReviewSummaryForBanner');
  }

  function openModal(review?: unknown) {
    return store.dispatch('reviews/openModal', review);
  }

  return {
    reviewsData,
    bannerSummary,
    isLoadingReviews,
    isLoadingBanner,
    modalReview,
    averageRating,
    numberOfRatings,
    reviews,
    getReviewsSummary,
    getReviewSummaryForBanner,
    openModal,
    getStarsUrl,
    getStarLabel,
    formatAverageRating,
    formatNumberOfRatings,
  };
}
